import * as R from 'ramda';
// Making TypeScript Happy with Ramda is herculean task
// https://github.com/ramda/ramda/wiki/Cookbook
// <T>(fn: () => any, obj: any) => T
export const mapKeys = R.curry((fn, obj) => R.fromPairs(
// @ts-ignore
R.map(R.adjust(fn, 0), R.toPairs(obj))));
// Alternate definition
// const mapKeys = R.curry((fn: () => any) =>
//     R.pipe(
//         R.toPairs,
//         R.map(R.adjust(fn, 0)),
//         R.fromPairs
//     ));
export const toCamel = (str) => str.charAt(0).toLowerCase() + str.slice(1);
export const mapToCamel = mapKeys(toCamel);
// Declaratively rename object keys
export const renameKeys = R.curry((keysMap, obj) => R.reduce((acc, key) => R.assoc(keysMap[key] || key, obj[key], acc), {}, R.keys(obj)));
//# sourceMappingURL=map.js.map